module.exports = __webpack_public_path__ + "static/media/caret-right.5e7a5bf3.svg";